/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box, Checkbox, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { kebabCase } from 'lodash';

type ToolbarSelectionDetailsProps = {
	title: string;
	description: ReactNode;
	children?: ReactNode;
	checked: boolean;
	onChange: ( checked: boolean ) => void;
};

export function ToolbarConfigDetails( { title, description, children, checked, onChange }: ToolbarSelectionDetailsProps ): ReactNode {
	const id = `toolbars-checkbox-${ kebabCase( title ) }`;

	return (
		<Box sx={ { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' } }>
			<Stack gap={ '2px' }>
				<Box sx={ { display: 'flex', alignItems: 'center', gap: '5px' } }>
					<Typography
						htmlFor={ id }
						component="label"
						fontSize={ '14px' }
						lineHeight={ '22px' }
						fontWeight={ 500 }
						color={ 'text.primary' }
						style={ { cursor: 'pointer' } }
					>
						{ title }
					</Typography>
				</Box>
				<Typography
					fontSize={ '12px' }
					lineHeight={ '20px' }
					fontWeight={ 400 }
					color={ 'text.secondary' }
					sx={ { padding: 0 } }
				>
					{ description }
				</Typography>
				{ children }
			</Stack>
			<Checkbox
				id={ id }
				checked={ checked }
				onChange={ () => onChange( !checked ) }
			/>
		</Box>
	);
}
